import type { RutaProd } from '../../../../runtime/rutas';
export default {
  ruta: '/sistema/punto-de-venta/configuraciones/tickets',
  documento: 'pos-settings',
  acceso: 'sesion',
  filas: ['070'],
  cita: 'Areas/POS_Settings/Controllers/SettingsController.cs:109',
} satisfies RutaProd;
